import { render } from "./Team_index_bar.vue?vue&type=template&id=8f8f8bc4&scoped=true"
import script from "./Team_index_bar.vue?vue&type=script&lang=js"
export * from "./Team_index_bar.vue?vue&type=script&lang=js"

import "./Team_index_bar.vue?vue&type=style&index=0&id=8f8f8bc4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8f8f8bc4"

export default script